import React, { useCallback } from "react";
import { TeleportTarget } from "@react-three/xr";
import * as THREE from "three";
import { QUAD_SIZE } from "../constants";

/**
 * GroundTeleport — invisible large plane laid over the quad ground that
 * accepts XR teleport rays / right-click teleport. On a hit, writes the
 * target position into the shared teleportRef so ThirdPersonWalker can
 * pick it up next frame.
 */
export default function GroundTeleport({ teleportRef }) {
  const onTeleport = useCallback(
    (pos) => {
      if (!teleportRef) return;
      const clampedX = THREE.MathUtils.clamp(pos.x, -QUAD_SIZE, QUAD_SIZE);
      const clampedZ = THREE.MathUtils.clamp(pos.z, -QUAD_SIZE, QUAD_SIZE);
      teleportRef.current = new THREE.Vector3(clampedX, 0, clampedZ);
    },
    [teleportRef]
  );

  return (
    <TeleportTarget onTeleport={onTeleport}>
      <mesh
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, 0.05, 0]}
        visible={false}
      >
        <planeGeometry args={[QUAD_SIZE * 2.4, QUAD_SIZE * 2.4]} />
        <meshBasicMaterial transparent opacity={0} />
      </mesh>
    </TeleportTarget>
  );
}
